import tpl from './non-compatible.tpl.html';
import './non-compatible-notification.scss';

/**
 * Displays details of a reason why some selection is not valid with current other selections.
 * Like "This person does not offer selected service."
 */
class NonCompatibleNotificationComponent {

  constructor($log, gettextCatalog) {
    'ngInject';
    this.$log = $log;
    this.gettextCatalog = gettextCatalog;

    /**
     * The errors list of string that will be shown by the component.
     * @type {Array}
     */
    this.mismatchErrors = [];
  }

  $onInit() {
    // Append mismatches separated by HTML line break
    this.notification_text = `${this.gettextCatalog.getString("Huom:")} ${this.mismatchErrors.join('<br/>')}`;
  }
}

const config = {
  templateUrl: tpl,
  controller: NonCompatibleNotificationComponent,
  bindings: {
    mismatchErrors: '<?'
  }
};

const mod = angular.module('app.nonCompatibleNotification', [])
  .component('nonCompatibleNotification', config)
;

export default mod.name;



// WEBPACK FOOTER //
// ./src/app/reservation/selections/non-compatible-notification.component.js